import { React, pr, theme, ui } from "aaa";

import { ICard } from "types/card";
import { CSSProperties } from "react";

export const Card = (props: {
    card: ICard,
    style?: {},
    checked?: boolean,
    separator?: boolean,
    onSelectCard?: (card: ICard) => void;
    ibanStyle?: React.CSSProperties,
}) => {
    return (
        <div
            role="button"
            style={{ position: "relative" }}
            onClick={() => {
                if (props.onSelectCard) {
                    return props.onSelectCard(props.card);
                }
            }}
        >
            <pr.HFlexCentered style={props.style}>
                <div style={{ flex: 1 }}>
                    <pr.P_18_TITLE>{props.card ? props.card.productI18N : "?"}</pr.P_18_TITLE>
                    <pr.P_14_CONTENT style={props.ibanStyle}>
                        {props.card.mainAccount ? props.card.mainAccount.iban : "?"}<br />
                        {props.card.number ? props.card.number : "?"}
                    </pr.P_14_CONTENT>
                </div>
                {props.checked &&
                    <div role="menuitem" aria-label={ui.__("a11y.selected")}>
                        <pr.IconCheck style={{ color: theme.customColors.georgeLightBlue }} />
                    </div>
                }
            </pr.HFlexCentered>
            {props.separator && <pr.LightSeparatorLine />}
        </div >
    );
};

export const CardShort = (props: { card?: ICard, showNumber?: boolean, showIban?: boolean, style?: CSSProperties }) => (
    <div style={props.style}>
        <pr.P_16_TITLE>{props.card ? props.card.productI18N : "?"}</pr.P_16_TITLE>
        {props.showNumber && <pr.P_16_TITLE>{props.card ? props.card.number : "?"}</pr.P_16_TITLE>}
        {props.showIban && <pr.P_16_TITLE>{props.card && props.card.mainAccount ? props.card.mainAccount.iban : "?"}</pr.P_16_TITLE>}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/common/Card.tsx